/* Inline add-to-cart for the "More From Titan" section.
   Submits via /cart/add.js so buyers stay on the 250 PDP; button flips to
   "ADDED ✓" then back. Falls through to a normal form POST on JS failure. */
(function () {
  // ---- UWD swatch → image swap ----
  var uwdImage    = document.querySelector('[data-pdp-250-uwd-image]');
  var uwdSwatches = document.querySelectorAll('[data-pdp-250-uwd-swatch]');
  if (uwdImage && uwdSwatches.length) {
    uwdSwatches.forEach(function (input) {
      input.addEventListener('change', function () {
        var src = input.getAttribute('data-image');
        if (src) uwdImage.setAttribute('src', src);
      });
    });
  }

  var forms = document.querySelectorAll('[data-pdp-250-more-form]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var btn   = form.querySelector('[data-pdp-250-more-cta]');
    var label = form.querySelector('[data-pdp-250-more-label]');
    if (!btn || !label) return;
    var original = label.textContent;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      btn.disabled = true;
      label.textContent = 'ADDING…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'HTTP ' + r.status); });
          return r.json();
        })
        .then(function () {
          btn.classList.add('is-added');
          label.textContent = 'ADDED ✓';
          setTimeout(function () {
            btn.classList.remove('is-added');
            label.textContent = original;
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          label.textContent = 'ERROR — RETRY';
          setTimeout(function () {
            label.textContent = original;
            btn.disabled = false;
          }, 2500);
        });
    });
  });
})();
